import * as actionTypes from "../actions/actionTypes";

const initialState: {} = {
  latitude: null,
  longitude: null,
  error: null,
};
const currentLocation = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CURRENT_LOCATION_SUCCESS: {
      return {
        ...state,
        latitude: action.position.latitude,
        longitude: action.position.longitude,
      };
    }
    case actionTypes.FETCH_CURRENT_LOCATION_FAILED: {
      return {
        ...state,
        error: action.error,
      };
    }
    case actionTypes.RESET_CURRENT_LOCATION:
      return {
        ...state,
        latitude: null,
        longitude: null,
        error: null,
      };

    default:
      return state;
  }
};

export default currentLocation;
